import {
  AutoDeposit,
  AutoDepositCancel,
  AutoDepositSuccess,
  AutoDepositV2,
  BankInfo,
  ContactUs,
  DeepLink,
  DeeplinkLP,
  DeeplinkSummary,
  DepositSuccessModal,
  DepositSummary,
  DuplicateTransaction,
  ECDD,
  FAQ,
  Feedback,
  FundDetails,
  FundSelectionStep2,
  //FundSelection,
  FundSelectionStep3,
  Gamification,
  GetStarted,
  GetStartedStep,
  GoalDetails,
  GoalList,
  Inbox,
  InboxItem,
  InvestIntroduction,
  InvestedFunds,
  MakeDeposit,
  MakeWithdrawal,
  MoreInfo,
  NewsList,
  OnBoarding,
  Plan,
  PlanSummary,
  PoliticalPosition,
  Profile,
  ProfileFormStepOne,
  ProfileFormStepTwo,
  ProfileInfo,
  PromoList,
  RetirementCashin,
  RetirementCashinSummary,
  RetirementDetail,
  RetirementFundSelection,
  RewardDetail,
  Rewards,
  RiskAssessment,
  RiskProfile,
  StepOne,
  StepThree,
  StepTwo,
  TaxInfo,
  Transaction,
  UpdateAddress,
  UpdateCity,
  UpdateCityOfBirth,
  UpdateEmail,
  UpdateEmployerAddress,
  UpdateEmployerName,
  UpdateInvesmentObj,
  UpdateOptInNotification,
  UpdatePostCode,
  UpdateTIN,
  UpdateVC,
  VerifyEmail,
  WithdrawalPending,
  WithdrawalSuccess,
  WithdrawalSummary,
} from "../../pages";

const routes = [
  {
    path: "/onBoarding",
    name: "On Boarding",
    component: OnBoarding,
    exact: true,
  },
  {
    path: "/onBoarding/form-step-one",
    name: "On Boarding Form Step One",
    component: ProfileFormStepOne,
    exact: true,
  },
  {
    path: "/onBoarding/form-step-two",
    name: "On Boarding Form Step Two",
    component: ProfileFormStepTwo,
    exact: true,
  },
  {
    path: "/onBoarding/ecdd/:from",
    name: "On Boarding ECDD",
    component: ECDD,
    exact: true,
  },
  // {
  //   path: "/onBoarding/intro",
  //   name: "On Boarding Intro",
  //   component: IntroPage,
  //   exact: true
  // },
  // {
  //   path: "/onBoarding/about",
  //   name: "On Boarding About",
  //   component: AboutPage,
  //   exact: true
  // },
  {
    path: "/version/:version",
    name: "Get Started Version",
    component: GetStartedStep,
    exact: true,
  },
  {
    path: "/",
    name: "Get Started",
    component: GetStarted,
    exact: true,
  },
  {
    path: "/getStartedInfo",
    name: "Get Started More Info",
    component: MoreInfo,
    exact: true,
  },
  {
    path: "/step-one",
    name: "Step One",
    component: StepOne,
    exact: true,
  },
  {
    path: "/step-two",
    name: "Step Two",
    component: StepTwo,
    exact: true,
  },
  {
    path: "/step-three",
    name: "Step Three",
    component: StepThree,
    exact: true,
  },
  {
    path: "/make-deposit/:from",
    name: "Make a Deposit",
    component: MakeDeposit,
    exact: true,
  },
  {
    path: "/make-deposit/:from/success",
    name: "Deposit Success",
    component: DepositSuccessModal,
    exact: true,
  },
  // {
  //   path: "/make-deposit/:from/success/auto-deposit/:setup",
  //   name: "Auto Deposit Edit",
  //   component: AutoDeposit,
  //   exact: true
  // },
  {
    path: "/make-deposit/:from/success/auto-deposit/:setup",
    name: "Auto Deposit Setup",
    component: AutoDeposit,
    exact: true,
  },

  {
    path: "/make-deposit/:form/success/rsp/success",
    name: "Auto Deposit Success",
    component: AutoDepositSuccess,
    exact: true,
  },
  {
    path: "/make-deposit/:from/success/auto-deposit/:setup/success-cancel",
    name: "Auto Deposit Cancel",
    component: AutoDepositCancel,
    exact: true,
  },
  // {
  //   path: "/make-deposit/:from/success/auto-deposit/cancel",
  //   name: "Auto Deposit Cancel",
  //   component: AutoDepositCancel,
  //   exact: true
  // },
  {
    path: "/make-deposit/:from/success/auto-deposit-v2/:setup",
    name: "Auto Deposit Setup V2",
    component: AutoDepositV2,
    exact: true,
  },
  {
    path: "/make-withdrawal",
    name: "Make a Withdrawal",
    component: MakeWithdrawal,
    exact: true,
  },
  {
    path: "/make-withdrawal/summary/:amount",
    name: "Withdrawal Summary",
    component: WithdrawalSummary,
    exact: true,
  },
  {
    path: "/make-withdrawal/bankInfo/:amount",
    name: "Bank Info",
    component: BankInfo,
    exact: true,
  },
  {
    path: "/make-withdrawal/success",
    name: "Withdrawal Success",
    component: WithdrawalSuccess,
    exact: true,
  },
  {
    path: "/make-withdrawal/pending",
    name: "Withdrawal Pending",
    component: WithdrawalPending,
    exact: true,
  },
  {
    path: "/make-withdrawal/duplicate-transaction",
    name: "Duplicate Transaction",
    component: DuplicateTransaction,
    exact: true,
  },
  {
    path: "/goal-list",
    name: "Goal List",
    component: GoalList,
    exact: true,
  },
  {
    path: "/goal-list/:id",
    name: "Goal Details",
    component: GoalDetails,
    exact: true,
  },
  {
    path: "/news-list",
    name: "News List",
    component: NewsList,
    exact: true,
  },
  {
    path: "/transaction",
    name: "Transaction",
    component: Transaction,
    exact: true,
  },
  {
    path: "/gamification",
    name: "Gamification",
    component: Gamification,
    exact: true,
  },
  {
    path: "/inbox",
    name: "Inbox",
    component: Inbox,
    exact: true,
  },
  {
    path: "/inbox/:id",
    name: "Inbox Item",
    component: InboxItem,
    exact: true,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    exact: true,
  },
  {
    path: "/profile/info",
    name: "Profile Info",
    component: ProfileInfo,
    exact: true,
  },
  {
    path: "/profile/info/updateEmail",
    name: "Update Email",
    component: UpdateEmail,
    exact: true,
  },
  {
    path: "/profile/info/updateEmail/verify/:email",
    name: "Verify Email",
    component: VerifyEmail,
    exact: true,
  },
  {
    path: "/profile/info/updateCityOfBirth",
    name: "Update City of Birth",
    component: UpdateCityOfBirth,
    exact: true,
  },
  {
    path: "/profile/info/updateAddress",
    name: "Update Address",
    component: UpdateAddress,
    exact: true,
  },
  {
    path: "/profile/info/updateCity",
    name: "Update City",
    component: UpdateCity,
    exact: true,
  },
  {
    path: "/profile/info/updatePostCode",
    name: "Update Post Code",
    component: UpdatePostCode,
    exact: true,
  },
  {
    path: "/profile/info/updateEmployerName",
    name: "Update Employer Name",
    component: UpdateEmployerName,
    exact: true,
  },
  {
    path: "/profile/info/updateEmployerAddress",
    name: "Update Employer Address",
    component: UpdateEmployerAddress,
    exact: true,
  },
  {
    path: "/profile/info/updateInvestObj",
    name: "Update Investment Objective",
    component: UpdateInvesmentObj,
    exact: true,
  },
  {
    path: "/profile/info/vc",
    name: "Update VC",
    component: UpdateVC,
    exact: true,
  },
  {
    path: "/profile/info/tin",
    name: "Update TIN",
    component: UpdateTIN,
    exact: true,
  },
  {
    path: "/profile/info/opt-in",
    name: "Update Opt-in Notification",
    component: UpdateOptInNotification,
    exact: true,
  },
  {
    path: "/profile/info/isPolitic",
    name: "Political Position",
    component: PoliticalPosition,
    exact: true,
  },
  {
    path: "/profile/info/taxInfo",
    name: "Tax Resident",
    component: TaxInfo,
    exact: true,
  },
  {
    path: "/profile/contactUs",
    name: "Contact Us",
    component: ContactUs,
    exact: true,
  },
  {
    path: "/profile/feedback",
    name: "Feedback",
    component: Feedback,
    exact: true,
  },
  {
    path: "/profile/faq",
    name: "FAQ",
    component: FAQ,
    exact: true,
  },
  {
    path: "/risk-profile",
    name: "Risk Profile",
    component: RiskProfile,
    exact: true,
  },
  {
    path: "/risk-assessment",
    name: "Risk Assessment",
    component: RiskAssessment,
    exact: true,
  },
  {
    path: "/fund-selection-step-two",
    name: "Fund Selection Step Two",
    component: FundSelectionStep2,
  },
  {
    path: "/fund-selection-step-three",
    name: "Fund Selection Step Three",
    component: FundSelectionStep3,
  },
  {
    path: "/invested-funds",
    name: "Invested Funds",
    component: InvestedFunds,
    exact: true,
  },
  {
    path: "/invested-funds/:id",
    name: "Fund Details",
    component: FundDetails,
    exact: true,
  },
  {
    path: "/invest-introduction",
    name: "Invest Introduction",
    component: InvestIntroduction,
    exact: true,
  },
  {
    path: "/rewards",
    name: "Rewards",
    component: Rewards,
    exact: true,
  },
  {
    path: "/rewards/detail",
    name: "Rewards Detail",
    component: RewardDetail,
    exact: true,
  },
  {
    path: "/promo-list",
    name: "Promo List",
    component: PromoList,
    exact: true,
  },
  {
    path: "/deposit-summary",
    name: "Deposit Summary",
    component: DepositSummary,
    exact: true,
  },
  {
    path: "/deeplink/:type/:code",
    name: "Deeplink",
    component: DeepLink,
    exact: true,
  },
  {
    path: "/deeplink/:type/:code/summary/:from",
    name: "Deeplink summary",
    component: DeeplinkSummary,
    exact: true,
  },
  {
    path: "/deeplink/status/:type/:code",
    name: "Deeplink Status",
    component: DeeplinkLP,
    exact: true,
  },
  {
    path: "/deeplink/invest-introduction",
    name: "Deeplink Invest Introduction",
    component: InvestIntroduction,
    exact: true,
  },
  {
    path: "/plan/auth/:plan",
    name: "Auth Plan",
    component: DeeplinkLP,
    exact: true,
  },
  {
    path: "/plan/:plan",
    name: "Plan",
    component: Plan,
    exact: true,
  },
  {
    path: "/plan/summary",
    name: "Plan Summary",
    component: PlanSummary,
    exact: true,
  },
  {
    path: "/risk-assessment/:from",
    name: "Deeplink Risk Assessment",
    component: RiskAssessment,
    exact: true,
  },
  {
    path: "/retirement/fund-selection",
    name: "Retirement Fund Selection",
    component: RetirementFundSelection,
    exact: true,
  },
  {
    path: "/retirement/cash-in",
    name: "Retirement Cash In",
    component: RetirementCashin,
    exact: true,
  },
  {
    path: "/retirement/summary",
    name: "Retirement Cash In Summary",
    component: RetirementCashinSummary,
    exact: true,
  },
  {
    path: "/retirement/invested-funds/:id",
    name: "Retirement Detail",
    component: RetirementDetail,
    exact: true,
  },
];

export default routes;
